import { useLanguage } from '../context/LanguageContext';
import { translate } from '../i18n/translations';

export function useTranslation() {
  const { lang, setLang } = useLanguage();
  const t = (key) => translate(lang, key);
  return { t, lang, setLang };
}
